import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const customerEvaluationState = atom<boolean>({
  key: 'customerEvaluationState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});
